module.exports = __webpack_public_path__ + "img/ic_publicity_detail1_5.c7314206.png";